module.exports = __webpack_public_path__ + "img/STERiGLIDE_02_10.16ece4b0.jpg";